import { useState } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "../../shared/components/Sidebar";
import TopBar from "../../shared/components/TopBar";

const DashboardPage = ({ user, onLogout }) => {
  // ✅ Sidebar control state (IMPORTANT)
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  return (
    <div className="dashboard">
      
      {/* ✅ SIDEBAR */}
      <Sidebar
        isOpen={isSidebarOpen}
        setIsOpen={setIsSidebarOpen}
      />

      <div className="dashboard-right">
        
        {/* ✅ TOPBAR */}
        <TopBar
          user={user}
          onLogout={onLogout}
          onToggleSidebar={() => setIsSidebarOpen(true)}
        />

        {/* ✅ MAIN CONTENT */}
        <div className="main-content">
          <Outlet />
        </div>

      </div>
    </div>
  );
};

export default DashboardPage;